import { Image } from 'grommet'

export default Image
